import React from 'react';

import { MenuWrapper, Menu, MenuItem, MenuDivider } from './styles';
import { PopoverBaseProps } from 'components/PopoverBase/types';
import APopover from 'components/APopover';

type OwnProps = {
  children: React.ReactNode;
  curveBorder?: boolean;
  marginToTarget?: number;
  target: React.ReactElement;
  width?: number | null;
  loading?: boolean;
};

type ComponentProps = OwnProps & PopoverBaseProps;

type DropdownType = {
  Menu: typeof Menu;
  MenuDivider: typeof MenuDivider;
  MenuItem: typeof MenuItem;
} & React.FC<ComponentProps>;

const Dropdown: DropdownType = ({
  children,
  curveBorder = true,
  marginToTarget,
  target,
  width = 200,
  ...props
}: ComponentProps) => {
  return (
    <APopover
      curveBorder={curveBorder}
      marginToTarget={marginToTarget}
      target={target}
      {...props}
    >
      <MenuWrapper width={width}>{children}</MenuWrapper>
    </APopover>
  );
};

Dropdown.Menu = Menu;
Dropdown.MenuDivider = MenuDivider;
Dropdown.MenuItem = MenuItem;

export default Dropdown;
